import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showHideMeetingRoomAddUsersModal } from 'actions/modal.js';
import { clearSearchUserForm } from 'actions/user.js';
import { previousPage } from 'actions/navigationBar';
import EmailUsersButton from '../../../shared/email-users-button/content';

export default function MeetingRoomManageUsersRightPanelOrTopPanel(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    var clipboard = new window.Clipboard('.copy-to-clipboard-email-all-mr-users');
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      e.clearSelection();
    });
  }, []);

  const openAddUserModal = () => {
    if (!areMeetingRoomUsersLoaded()) return;
    dispatch(clearSearchUserForm());
    dispatch(showHideMeetingRoomAddUsersModal(true));
  };

  const areMeetingRoomUsersAvailable = () => {
    return !props.fetchingUserICanManage && props.usersIcanManage && props.usersIcanManage.length > 0;
  };

  const areMeetingRoomUsersLoaded = () => {
    return !props.fetchingUserICanManage && props.usersIcanManage;
  };

  const buttonsForDesktop = (
    <div>
      <button
        type="button"
        className={`ui labeled icon button mrbs color-button color-white right-hand-side-button ${
          !areMeetingRoomUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
        {APP.LANGUAGE.MeetingRoomManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={props.selectedMRUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areMeetingRoomUsersAvailable()}
        entityName={props.meetingRoomName}
        areUsersLoaded={areMeetingRoomUsersLoaded()}
        isDesktop={true}
      />
    </div>
  );

  const buttonsForTablet = (
    <div>
      <button
        className={`ui labeled icon button color-button color-white right-hand-side-button mrrsss ${
          !areMeetingRoomUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i
          className="plus icon"
          ref={(el) => {
            if (el) {
              el.style.setProperty('font-size', '1em', 'important');
            }
          }}
        />
        {APP.LANGUAGE.MeetingRoomManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={props.selectedMRUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areMeetingRoomUsersAvailable()}
        entityName={props.meetingRoomName}
        areUsersLoaded={areMeetingRoomUsersLoaded()}
        isTab={true}
      />
    </div>
  );

  const buttonsForMobile = (
    <div>
      <button
        className={`ui icon button color-button color-white mrrsss mrbml ${
          !areMeetingRoomUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
      </button>

      <EmailUsersButton
        userEmails={props.selectedMRUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areMeetingRoomUsersAvailable()}
        entityName={props.meetingRoomName}
        areUsersLoaded={areMeetingRoomUsersLoaded()}
        isMobile={true}
      />
    </div>
  );
  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo} />
          </div>
          <div className="pdbs pdll pdrm">{buttonsForDesktop}</div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
      <Container fluid as={Media} at="tablet">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForTablet}</div>
          <div className="mrts pdts mrbm">
            <Link
              className={
                (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? 'back-to-org-link '
                  : 'back-to-mr-link ') + 'left-text pdlm pdbs'
              }
              to={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? `/organisational-unit/view-all`
                  : `/meeting-room/view-all`
              }
              onClick={() => {
                dispatch(previousPage(APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle));
              }}
            >
              <i className="chevron circle left icon" />
              <span>
                {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                  : APP.LANGUAGE.MeetingRoomManageUsers.BackToMeetingRoomsLinkText}
              </span>
            </Link>
          </div>
        </div>
      </Container>
      <Container as={Media} at="mobile">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForMobile}</div>
          <div className="pdtxs mrbs">
            <Link
              className={
                (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? 'back-to-org-link '
                  : 'back-to-mr-link ') + 'left-text pdlm pdbs'
              }
              to={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? `/organisational-unit/view-all`
                  : `/meeting-room/view-all`
              }
              onClick={() => {
                dispatch(previousPage(APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle));
              }}
            >
              <i className="chevron circle left icon" />
              <span>
                {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                  : APP.LANGUAGE.MeetingRoomManageUsers.BackToMeetingRoomsLinkText}
              </span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
